import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { DownloadButtons } from '../../components/empty/download-buttons';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';

function useNewMenuModal({ onAppDownloadClick }) {
  const storage = useStorage();
  const { t } = useTranslation();
  const { swal } = useSwal({ storage });
  const classes = useStyles();

  async function load() {
    // const x = xRef.current;
  }

  async function fire() {
    await swal.fire({
      title: t('new-menu-modal.title'),
      html: (
        <>
          <div className={classes.descriptionContainer}>
            <span className={classes.topDescription}>
              {t('new-menu-modal.description.top')}
            </span>
          </div>

          <DownloadButtons
            shakeEnabled
            onAppDownloadClick={onAppDownloadClick}
          />

          <div className={classes.descriptionContainer}>
            <span className={classes.bottomDescription}>
              {t('new-menu-modal.description.bottom')}
            </span>
          </div>
        </>
      ),
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
    });
  }

  return [load, fire];
}

const useStyles = createUseStyles({
  buttonsContainer: {
    display: 'flex',
    // flexWrap: 'wrap',
    border: '1px solid red',
  },
  descriptionContainer: {
    // textAlign: 'start',
    marginTop: layoutDefaults.bigVerticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,
  },
  topDescription: {
    fontSize: layoutDefaults.bigFontSize,
  },
  bottomDescription: {
    fontSize: layoutDefaults.fontSize,
    opacity: layoutDefaults.opacity + 0.2,
  },
  link: {
    cursor: 'pointer',
    // textAlign: 'center',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    // border: "1px solid red",
  },
});

export { useNewMenuModal };
